/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsDataManagerObjectClassesEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsDataManagerObjectClassesEntryPoint: EntryPoint<
	AssetsDataManagerObjectClassesEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerObjectClassesEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-object-classes-page", jiraSpaEntry: "async-assets-data-manager-object-classes-page" */ './AssetsDataManagerObjectClasssPageSpa.tsx',
	),
	getPreloadProps: () => ({}),
});
